import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useFavourites } from "../lib/favourites";

export const FavouriteButton = ({ o, className = "" }) => {
  const { isSaved, toggle } = useFavourites();
  const saved = isSaved(o.id);
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(o);
    toast.success(saved ? "Removed from saved" : "Saved — find it under Saved on the Volunteer page");
  };
  return (
    <button onClick={onClick} aria-pressed={saved} aria-label={saved ? "Remove from saved" : "Save for later"} data-testid={`favourite-toggle-${o.id}`}
      className={`rounded-full p-2 transition-colors ${saved ? "bg-rose-50 text-rose-500" : "bg-white/80 text-slate-400 hover:text-rose-500"} ${className}`}>
      <Heart size={17} fill={saved ? "currentColor" : "none"} />
    </button>
  );
};
